import { ReactNode } from 'react';
import { FlagId, MessagesSortBy, MonitId } from '../../../models/communication.types';
import { SelectableTablePossibleCellsType } from '../../SelectableTable/SelectableTable.types';

export interface MessageTableItem {
  [key: string]: SelectableTablePossibleCellsType;
  id: string;
  flag: ReactNode;
  flagId: FlagId | null;
  participant: ReactNode;
  subject: ReactNode;
  assessmentSession: ReactNode;
  monit: ReactNode;
  sendDate: ReactNode;
}

export interface FolderMessageTableItem extends MessageTableItem {
  externalRow?: ReactNode;
}

export interface MessagesFilter {
  flag: FlagId[];
  sender: string;
  recipient: string;
  subject: string;
  participant: string;
  assessmentSession: string;
  sentDateFrom: string;
  sentDateTo: string;
  monit: MonitId[];
  isUnread: boolean;
}

export interface MessagesFilterElements {
  flag: JSX.Element;
  monit: JSX.Element;
  sendDate: JSX.Element;
}

export enum TableMessageParticipant {
  recipient,
  sender,
}

export type MessagesSortById = 'flag' | 'participant' | 'subject' | 'session' | 'monit' | 'sendDate';

export const translateMessagesSortByIdToMessagesSortBy = (id: MessagesSortById): MessagesSortBy => {
  switch (id) {
    case 'flag':
      return MessagesSortBy.Flag;
    case 'participant':
      return MessagesSortBy.Author;
    case 'subject':
      return MessagesSortBy.Subject;
    case 'session':
      return MessagesSortBy.AssessmentSession;
    case 'monit':
      return MessagesSortBy.Monit;
    default:
      return MessagesSortBy.SentDate;
  }
};
